// extracted by mini-css-extract-plugin
export default {"statCard":"stat-card_statCard__nM3O2","statContent":"stat-card_statContent__nEtIz","statNumber":"stat-card_statNumber__kO+lf","statLabel":"stat-card_statLabel__G8yhu"};